import React from "react";
import "./IconSection.css"; // Optional: Include your CSS for styling

export default function IconSection() {
  const IconText = [
    {
      id: 1,
      heading: "Customised Printing Services",
      icon: '/printer.gif',
      description: "Tailored solutions for marketing, branding, and operational needs."
    },
    {
      id: 2,
      heading: "Advanced Printing Technology",
      icon: '/cloud.gif',
      description: "High-resolution printing with durable materials for impactful results."
    },
    {
      id: 3,
      heading: "Efficient Bulk Solutions",
      icon: '/idea.gif',
      description: "Competitive pricing and quick turnaround times for large-scale orders."
    },
  ];

  return (
    <div className="container icon-section">
      <div className="row">
        {IconText.map((item) => (
          <div key={item.id} className="col-md-4 text-center mb-4">
            <div className="icon-card">
              <img
                src={item.icon}
                alt={item.heading}
                className="icon-image"
              />
              <h5 className="icon-heading">{item.heading} </h5>
              <p className="icon-description">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
